module.exports = __webpack_public_path__ + "img/pd.0f27f723.png";